import React from 'react'
import classNames from 'classnames'

import { useIntersectionContext } from 'marketing-site/src/components/context/IntersectionContext'
import { useVerticalObserver } from '../../hooks/use-vertical-observer'
import { IProps } from './index'

export const StickyContent: React.FC<IProps> = ({
  anchorId,
  marginBottom,
  threshold,
  contentPosition,
  hasSpacingAround = true,
  children,
}) => {
  const { currentItems } = useIntersectionContext()

  useVerticalObserver({
    rootMargin: `0px 0px ${marginBottom} 0px`,
    threshold,
  })

  const classes = classNames('sticky-content', {
    'sticky-content--visible': currentItems?.some((item) => item === anchorId),
  })

  return (
    <>
      <div className={classes}>{children}</div>

      <style jsx>
        {`
          .sticky-content {
            visibility: hidden;
            opacity: 0;
            position: fixed;
            top: ${contentPosition === 'top' ? 'var(--header-height)' : 'unset'};
            bottom: ${contentPosition === 'bottom' ? '0' : 'unset'};
            width: 100%;
            padding: ${hasSpacingAround ? '1.5rem' : '0'};
            z-index: 111;
            flex-direction: column;
            align-items: center;
            background-color: $white;
            transition: opacity 0.24s, visibility 0s ease 0.24s;

            &--visible {
              visibility: visible;
              opacity: 1;
              transition: opacity 0.24s, visibility 0s;
            }

            :global(.section--richTextEditor) {
              margin: 0 !important;
              width: 50%;
            }
          }
        `}
      </style>
    </>
  )
}
